import { useEffect, useState } from "react";
import "./student-courses.css";
import { Link } from "react-router-dom";
import {
  capitalizeAll,
  isEmpty,
  slugify,
  convertDuration,
  wait
} from "../../../../core/utils/helpers";
import Button from "../../../../ui/atoms/buttons/Button";
import ASSETS from "../../../../app/config/assets";
import ChapterItem from "../../components/chapter-item/ChapterItem";
import { useSelector } from "react-redux";
import { onGetStudentCourses } from "../../services/course";
import NotFound from "../../../../ui/organisms/not-found/404";
import Loading from "../../../../ui/atoms/loading/Loading";
import useAxiosPrivate from "../../../../app/providers/context-provider/useAxiosPrivate";

const StudentCourseContent = () => {
  const axiosPrivate = useAxiosPrivate();

  const [isLoading, setIsLoading] = useState(true);

  const [isPreviewCourse, setIsPreviewCourse] = useState(false);
  const [coursesData, setCoursesData] = useState([]);
  const [currentCourse, setCurrentCourse] = useState({});

  const currentConnectedStream = useSelector(
    (state) => state.setInitConf.currentConnectedStream,
  );

  const _inscription_id = currentConnectedStream?.inscription_id;
  const _stream_id = currentConnectedStream?.stream_id;

  useEffect(() => {
    const fetchData = async () => {
      await wait(1500);

      let isMounted = true;
      const controller = new AbortController();
      const signal = controller.signal;

      const localData = {
        inscription_id: _inscription_id,
        stream_id: _stream_id,
      };

      onGetStudentCourses(axiosPrivate, localData, signal).then((response) => {
        const _data = response?.data;
        const _data_activated = _data?.result?.filter(
          (row) =>
            row.course_is_activated &&
            !row.course_is_deleted &&
            row?.course_chapters?.length > 0,
        );
        setCoursesData(_data_activated || []);
      });

      setIsLoading(false);

      return () => {
        isMounted = false;
        isMounted && controller.abort();
      };
    };

    fetchData();
  }, []);

  const onCoursePreview = (course) => {
    setCurrentCourse(course);
    setIsPreviewCourse(!isPreviewCourse);
  };

  return (
    <div className="w-full h-full">
      {isLoading ? (
        <Loading type={"type-2"} />
      ) : (
        <div className="st-c-container">
          {isEmpty(coursesData) ? (
            <NotFound
              type={"data"}
              title={"No Course found!"}
              text={"No course available yet!"}
              isBoutton={false}
            />
          ) : (
            coursesData?.map((course, idx) => {
              return (
                <div
                  className="course-item"
                  onClick={() => onCoursePreview(course)}
                  key={idx}
                >
                  <img
                    src={process.env.PUBLIC_URL + "/board.jpg"}
                    alt="course banner illustration"
                  />
                  <div className="ci-outer">
                    <h3 className="t-2">
                      {capitalizeAll(course?.course_title)}
                    </h3>
                    <div className="ci-details">
                      <span>
                        {course?.course_total_chapters}{" "}
                        {course?.course_total_chapters > 1
                          ? "Chapters"
                          : "Chapter"}
                      </span>
                      <span>&</span>
                      <span>
                        {course?.course_total_lessons}{" "}
                        {course?.course_total_lessons > 1
                          ? "Lessons"
                          : "Lesson"}
                      </span>
                    </div>
                    <p>{convertDuration(course?.course_timing)}</p>
                  </div>
                </div>
              );
            })
          )}
        </div>
      )}
      {isPreviewCourse && (
        <div className="st-c-preview">
          <div className="st-c-p-wrapper">
            <div className="st-c-p-w-head">
              <Button
                type={"button"}
                preferedStyle={"default"}
                title={"Cancel"}
                action={() => setIsPreviewCourse(!isPreviewCourse)}
              />
            </div>
            <div className="st-c-p-w-banner">
              <div className="banner-back">
                <img
                  src={process.env.PUBLIC_URL + "/board.jpg"}
                  alt="course banner illustration"
                />
              </div>
              <Link
                to={`/student/courses/${currentCourse?.course_title}/reading?viewId=${currentCourse?.course_id}`}
                className="banner-front"
              >
                <img
                  src={ASSETS?.icon_online_class_gif}
                  alt="icon start learning course"
                />
                <span>Start Course</span>
              </Link>
            </div>
            <div className="st-c-p-w-content">
              <h1>{capitalizeAll(currentCourse?.course_title)}</h1>
              <p>{currentCourse?.course_description}</p>
              <div className="w-full d-flex flex-col">
                {currentCourse?.course_chapters?.map((chapter, j) => {
                  return (
                    <ChapterItem type={"preview"} chapter={chapter} key={j} />
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default StudentCourseContent;
